import { Box, MenuItem, Select, SelectChangeEvent, Typography } from '@mui/material';

const ALL_VALUE = 'all';

export const PUBLISHER_OPTIONS: { label: string; value: string }[] = [
  { label: '전체', value: ALL_VALUE },
  { label: '버즈빌', value: 'buzzvil' },
  { label: '아바티', value: 'avatye' },
];

interface PublisherFilterProps {
  selected?: string;
  onSelect: (publisher?: string) => void;
}

export default function PublisherFilter({ selected, onSelect }: PublisherFilterProps) {
  const handleChange = (e: SelectChangeEvent) => {
    const value = e.target.value;
    onSelect(value === ALL_VALUE ? undefined : value);
  };

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
      <Typography fontWeight={500} fontSize="0.85rem" color="#64748b" sx={{ whiteSpace: 'nowrap' }}>
        구분
      </Typography>
      <Select
        value={selected ?? ALL_VALUE}
        onChange={handleChange}
        size="small"
        sx={{
          minWidth: 160,
          bgcolor: '#f8fafc',
          borderRadius: 2.5,
          '& .MuiOutlinedInput-notchedOutline': { borderColor: '#e2e8f0' },
          '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: '#cbd5e1' },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: '#0044D2' },
        }}
      >
        {PUBLISHER_OPTIONS.map(({ label, value }) => (
          <MenuItem key={value} value={value}>
            {label}
          </MenuItem>
        ))}
      </Select>
    </Box>
  );
}
